import React, { Component } from "react";
import PropTypes from "prop-types";
import * as uuid from "react-native-uuid";
import Client from "../../Client";
import RunsheetController from "./RunsheetController";

class RunsheetCopy extends Component {
  state = {
    fetched: false,
    runsheet: {}
  };

  componentDidMount() {
    Client.duplicateRunsheet(this.props.match.params.id).then(runsheet => {
      const duplicateJobs = runsheet.jobs.map(job => ({
        ...job,
        id: null,
        externalId: uuid.v4()
      }));
      const duplicatedRunsheet = {
        ...runsheet,
        name: `${runsheet.name || ""} (Copy)`,
        id: null,
        externalId: "",
        jobs: duplicateJobs
      };

      this.setState({
        fetched: true,
        runsheet: duplicatedRunsheet
      });
    });
  }

  handleChange = runsheet => {
    this.setState({ runsheet });
    Client.createRunsheet(runsheet).then(response =>
      this.props.history.push(`/runsheets/${response.id}`)
    );
  };

  render() {
    if (this.state.fetched) {
      return (
        <div>
          <RunsheetController
            mode="COPY"
            runsheetExternalId={this.props.match.params.id}
            history={this.props.history}
            initialRunsheet={this.state.runsheet}
            onChange={this.handleChange}
          />
        </div>
      );
    }
    return <p>Loading...</p>;
  }
}
RunsheetCopy.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired
};

export default RunsheetCopy;



// WEBPACK FOOTER //
// ./src/components/runsheets/RunsheetCopy.js